import React, {useState}from 'react'
import logo from '../assets/img/mjlogo.png';
import API_URL from '../Config';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import axios from 'axios';

const ResetAdminPassword = () => {
      const location =useLocation();
      const [email, setEmail] = useState(location.state?.email ||'');
      const [code, setCode] = useState('');
      const [password, setPassword] = useState('');
      const [confirmPassword, setConfirmPassword] = useState('');
      const [errors, setErrors] = useState({});
      const [currentStep, setCurrentStep] = useState(1);
      
    
      const navigate = useNavigate();
    
      // Validation for password fields
      const validateForm = () => {
        let isValid = true;
        const newErrors = {};
    
        if (!password.trim()) {
          newErrors.password = 'Password is required';
          isValid = false;
        } else if (password.length < 6 || password.length > 15) {
          newErrors.password = 'Password must be between 6 and 15 characters';
          isValid = false;
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
          newErrors.password = 'Password must contain at least one special character';
          isValid = false;
        }
    
        if (!confirmPassword.trim()) {
          newErrors.confirmPassword = 'Confirm Password is required';
          isValid = false;
        } else if (password !== confirmPassword) {
          newErrors.confirmPassword = 'Passwords do not match';
          isValid = false;
        }
    
        setErrors(newErrors);
        return isValid;
      };
    
      const nextStep = () => setCurrentStep((prev) => prev + 1);
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
    
        try {
          const sendData = { email, password };
          const res = await fetch(`${API_URL}/api/v2/admin/forgetPassword`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(sendData),
          });
    
          if (res.ok) {
            toast.success('Password changed successfully! Redirecting...');
            navigate('/admin');
          } else {
            const err = await res.json();
            toast.error(err.message);
          }
        } catch (error) {
          toast.error('Unexpected error. Try again.');
        }
      };
  return (
  <div className="w-screen h-screen overflow-hidden flex items-center justify-center bg-gradient-to-b from-black to-blue-950">
    <div className="grid grid-cols-1 md:grid-cols-2 items-center justify-center text-white px-4 sm:px-6 lg:px-12 w-full max-w-6xl scale-105 sm:scale-110 lg:scale-125">
      
      {/* Left: Logo */}
      <div className="hidden md:flex justify-center items-center">
        <img src={logo} alt="Media Jungle" className="w-40 sm:w-64 lg:w-[32rem] object-contain" />
      </div>

      {/* Right: Forget Password Steps */}
      <div className="w-full max-w-sm mx-auto">
        <div className="text-center mb-8">
              <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-white">Welcome</h1>
              <p className="text-lg sm:text-xl text-gray-300">
                <span className="font-bold text-white">Admin</span>
              </p>
            </div>
<span className="font-bold text-white">Reset Password</span>
        
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="password"
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 rounded-lg text-black"
              required
            />
            <input
                    type="password"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="w-full px-3 py-2 rounded-lg text-black"
                    required
                  />

                  {errors.password && (
    <p className="text-red-500 text-sm">{errors.password}</p>
  )}
  {errors.confirmPassword && (
    <p className="text-red-500 text-sm">{errors.confirmPassword}</p>
  )}

            <button 
            type="submit"
            className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-2 rounded-lg">
              Set Password
            </button>
          </form>
      </div>
    </div>
  </div>
);
}

export default ResetAdminPassword